import { render, staticRenderFns } from "./UppyUploader.vue?vue&type=template&id=c4180058&scoped=true&"
import script from "./UppyUploader.vue?vue&type=script&lang=js&"
export * from "./UppyUploader.vue?vue&type=script&lang=js&"
import style0 from "./UppyUploader.vue?vue&type=style&index=0&id=c4180058&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4180058",
  null
  
)

export default component.exports